import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class RadioOptionsComponent extends Component {
  @action
  selectOption(option) {
    if (this.args.changeset) {
      this.args.changeset.set(this.args.name, option.value);
    }
    this.args?.handleOptionSelect?.(option);
  }
}
